import { useLocalStore } from 'mobx-react-lite';

import { PopupStore } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { GroupType } from 'APP/model/group/groupModel.types';

import { IGroupFormInitialValues } from '../../components/GroupForm/GroupForm.types';

interface ICreateChatGroupPopupPresenter {
  initialValues: IGroupFormInitialValues;
  onSubmit(groupData: IGroupFormInitialValues): Promise<void>;
}

export function useCreateChatGroupPopupPresenter(
  popupInstance: PopupStore
): ICreateChatGroupPopupPresenter {
  const presenter = useLocalStore<ICreateChatGroupPopupPresenter>(() => ({
    initialValues: { type: GroupType.Closed },

    async onSubmit(groupData: IGroupFormInitialValues): Promise<void> {
      await Tasks.group.createGroupAndInvite({ ...groupData });
      popupInstance.close();
    },
  }));

  return presenter;
}
